// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"FiltersHeading_visuallyHidden__xqYYW"};